import { motion } from 'framer-motion';
import styled from 'styled-components';

interface CardImageWrapperProps {
    src: string;
}

export const CardImageWrapper = styled(motion.div)<CardImageWrapperProps>`
    width: 43rem;
    height: 21.875rem;
    padding: 1.5rem;
    gap: 0.8rem;
    border-radius: 1.875rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    z-index: 0;

    background: url(${({ src }) => src});
    background-size: cover;
    

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: start;

    color: ${({ theme }) => theme.colors.primary};
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-weight: 700;

    transition: background 0.1s;

    &.park {
        background-position: bottom;
    }

    @media (max-width: 1200px) {
        width: 36rem;
        height: 18.75rem;
    }

    @media (max-width: 992px) {
        width: 30rem;
        height: 15.625rem;
        padding: 1rem;
    }

    @media (max-width: 768px) {
        width: 24rem;
        height: 12.5rem;
    }

    .containerIconText {
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        gap: 0.5rem;

        width: 100%;
        height: 100%;

        svg {
            width: 2rem;
            height: 2rem;
        }
    }

    .wrapReltiveIcon {
        padding: 1rem;
        position: absolute;
        right: 0;
        top: 0;
    }

    .description {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        bottom: 1.5rem;
        left: 1.5rem;
        width: calc(100% - 3rem);
        gap: 0.5rem;

        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: bold;
        font-weight: 400;

        div {
            font-size: 1rem;
            font-weight: 500;
            display: flex;
            gap: 0.7rem;
            align-items: center;
        }
    }

    & > * {
        z-index: 2;
    }

    &::before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.31) 31%,
            rgba(0, 0, 0, .9) 94%
        );
        inset: 0;
        opacity: .1;

        z-index: 1;
        transition: opacity .3s;
    }

    &:hover::before {
        opacity: 1;
    }
`;
